import {
    InlineOptions
} from '../../imports/fancybox-options'
export default class accountshippingCtrl {
    constructor($scope, $http, $rootScope, $compile) {
        'ngInject';
        $scope.regions = {};
        $scope.currentAddress = {};
        $scope.addressSaving = false;
        $scope.validationOptions = {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messages: {
                email: {
                    required: "We need your email address to contact you",
                    email: "Your email address must be in the format of name@domain.com"
                }
            },
            ignore: [],
            errorPlacement: function (error, element) {
                if ($(element).is(":hidden")) {
                    var hidELement = $(element).parent().parent();
                    error.insertAfter(hidELement);
                } else {
                    var element = $(element);
                    error.insertAfter(element);
                }
            },
            highlight: function (element, errorClass, validClass) {
                if ($(element).is(":hidden")) {
                    $(element)
                        .parent()
                        .addClass(errorClass)
                        .removeClass(validClass);
                } else {
                    $(element)
                        .addClass(errorClass)
                        .removeClass(validClass);
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if ($(element).is(":hidden")) {
                    $(element)
                        .parent()
                        .removeClass(errorClass)
                        .addClass(validClass);
                } else {
                    $(element)
                        .removeClass(errorClass)
                        .addClass(validClass);
                }
            }
        };

        $scope.fancyboxOptions = InlineOptions;

        var AccountCtrl = angular.element('#account-wrap').scope();

        $scope.create = function () {
            $scope.currentAddress = {};
            $scope.currentAddress.type = "NEW";
            // $scope.currentAddress.shipping_region = 0;
            $.fancybox.open({
                src: "#new-address",
                type: "inline",
                opts: $scope.fancyboxOptions
            });
            try {
                $('#new-address select').select2('destroy');
            } catch (e) {

            }
            // $('.select2Search').select2({ zIndex: "99994", });
            setTimeout(function () {
                $('select.select2Search').select2({
                    width: "100%",
                    theme: "default",
                    // minimumResultsForSearch: -1,
                });
            }, 100);
        };

        $scope.store = function ($event) {
            if (!$scope.currentAddressFormName.validate()) {
                $event.preventDefault();
            }else{
                var _data = $scope.currentAddress;
                _data._token = window.Laravel.csrfToken;
                $scope.addressSaving = true;
                $http({
                    method: "POST",
                    url: "/en/account/address",
                    data: _data
                }).then(function success(response) {
                    $scope.addressSaving = false;
                    var data = response.data;
                    AccountCtrl.getUserShippingDetails();
                    $.fancybox.close();
                    $scope.currentAddress = {};
                }, function error(response) {
                    $scope.addressSaving = false;
                    var data = response.data;
                });
            }
        }

        $scope.edit = function (_id) {
            $scope.currentAddress = [];
            $http({
                method: "GET",
                url: "/account/address/" + _id,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then(function success(response) {
                var data = response.data;
                $scope.currentAddress = data;
                $scope.currentAddress.type = "EDIT";
                $.fancybox.open({
                    src: "#new-address",
                    type: "inline",
                    opts: $scope.fancyboxOptions
                });
                try {
                    $('#new-address select').select2('destroy');
                } catch (e) {}
                setTimeout(function () {
                    $('select.select2Search').select2({
                        width: "100%",
                        theme: "default",
                        // minimumResultsForSearch: -1,
                    });
                }, 100);
            }, function error() {

            });

        };

        $scope.update = function (_id, $event) {
            if (typeof _id === 'undefined') {
                $scope.store($event);
            } else {
                if (!$scope.currentAddressFormName.validate()) {
                    $event.preventDefault();
                }else{
                    var _data = $scope.currentAddress;
                    $scope.addressSaving = true;
                    $http({
                        method: "PUT",
                        url: "/account/address/" + _id,
                        data: _data
                    }).then(function success(response) {
                        var data = response.data;
                        $scope.addressSaving = false;
                        AccountCtrl.getUserShippingDetails();
                        $.fancybox.close();
                        $scope.currentAddress = {};

                    }, function error(response) {
                        $scope.addressSaving = false;
                        var data = response.data;
                    });
                }
            }
        };

        $scope.make_default = function (_id) {
            $rootScope.showOverlay('account');
            $http({
                method: "PATCH",
                url: "/account/address/" + _id,
            }).then(function success(response) {
                AccountCtrl.getUserShippingDetails();
                var data = response.data;
                $scope.currentAddress = {};
            }, function error(response) {
                var data = response.data;
            });
        };

        $scope.deleteForm = function (_id) {
            $scope.currentAddress = [];
            $http({
                method: "GET",
                url: "/account/address/" + _id,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then(function success(response) {
                var data = response.data;
                $scope.currentAddress = data;
                $.fancybox.open({
                    src: "#confirm-del",
                    type: "inline",
                    opts: $scope.fancyboxOptions
                });
            }, function error() {

            });
        };

        $scope.delete = function (confirm) {
            if (confirm == 0) {
                $.fancybox.close();
                return false;
            }
            if ($scope.currentAddress) {
                $http({
                    method: "DELETE",
                    url: "/account/address/" + $scope.currentAddress.id
                }).then(function success(response) {
                    var data = response.data;
                    AccountCtrl.getUserShippingDetails();
                    $.fancybox.close();
                }, function error(response) {
                    var data = response.data;
                    AccountCtrl.getUserShippingDetails();
                    $.fancybox.close();
                });
            }
            // $scope.currentAddress = {};
            $scope.deleteAddress = 0;
        };

        $scope.getRegions = function (_country) {
            $http({
                method: "GET",
                url: "/checkout-delivery-details/get-all-areas/" + _country,
            }).then(function success(response) {
                var data = response.data;
                $scope.regions = data;
                setTimeout(function () {
                    $('#new-address-region').change();
                }, 200)
            }, function error(response) {
                var data = response.data;
            });
        };

        /**
         * Watchers
         */

         
        $scope.$watch("currentAddress.shipping_country", function (newValue, oldValue) {
            if (typeof newValue !== 'undefined') {
                setTimeout(function () {
                    $scope.getRegions(newValue);
                }, 100);
            }
        });

        // $scope.getRegions(-1);
        
    }
}